export default __webpack_public_path__ + "static/media/Yeve_C._Sibanda_AHV_In_Moms_We_Trust.7b737598.jpg";